import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { FilterKeyType } from '@ocean/types/dist/filter'
import { FilterUtils } from '@ocean/utils'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getListSimulatorExercises } from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/api/exerciseListService'
import {
  SimulatorExercise,
  ExerciseListFilterItem,
  ExerciseListFilterItems,
} from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/types'
import { ExerciseListUtils } from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/utils'
import { ExerciseListState, ApiExerciseListResponse } from './types'

const initialState: ExerciseListState = {
  simulatorExercisesListData: {},
  filters: {
    search: { keyType: FilterKeyType.String, searchKey: ['name', 'type', 'author'] },
    type: { keyType: FilterKeyType.String },
  },
}

const exerciseListSlice = createSlice({
  name: 'simulatorTrainingInstructorSLExerciseList',
  initialState,
  reducers: {
    listSimulatorExercisesLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiExerciseListResponse>>
    ) {
      state.simulatorExercisesListData = action.payload
    },
    setFilters(state, action: PayloadAction<ExerciseListFilterItem>) {
      const filter = state.filters[action.payload.name]
      if (filter) filter.value = action.payload.value
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { listSimulatorExercisesLoaded, setFilters } = exerciseListSlice.actions
export { setFilters }
export default exerciseListSlice.reducer

export const getFilteredExerciseList = createSelector(
  (exercises: SimulatorExercise[] = [], filters: ExerciseListFilterItems) => ({
    exercises,
    filters,
  }),
  ({ exercises, filters }) => FilterUtils.filterData(filters, exercises)
)

export const getExerciseTypes = createSelector(
  (exercises: SimulatorExercise[] = []) => exercises,
  exercises => ExerciseListUtils.getExercisesTypes(exercises)
)

export const getExerciseItem = createSelector(
  (exercises: SimulatorExercise[] = [], trainingId: Guid) => ({ exercises, trainingId }),
  ({ exercises, trainingId }) => exercises.find(({ id }) => id === trainingId)
)

export const loadListSimulatorExercises = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      list: getListSimulatorExercises,
    },
    payloadAction: listSimulatorExercisesLoaded,
  })
}
